import { t } from '../../../../utils/i18n'
import styles from './_songTabs.module.scss'

import SongActions from './SongActions'
import SongDetails from './SongDetails'
import BlurredContent from './BlurredContent'

import {
  Change,
  ChordItem,
  initializeTabsLogic,
  SongPart,
  SortableList
} from '../../../../utils/songs/songTabsCommon'
import { useAuth } from '../../../../utils/auth'
import { useContext, useEffect } from 'react'
import { isMobile } from '../../../../utils/deviceDetection'
import { SongPageContext } from '..'
import { Song } from '../../../../__generated__/graphql'
import useInView from 'react-cool-inview'

const LyricsTab: React.FC<{
  song: Song
  changes: Array<Change>
  setChanges: (change: Array<Change>) => void
  setSongStructure: (change: Array<ChordItem>) => void
}> = ({ song, changes, setChanges, setSongStructure }) => {
  const { currentUser } = useAuth()
  const { lyricsCharts } = useContext(SongPageContext)

  const {
    hasChanges,
    backToDefault,
    undo,
    fakeChordItems,
    pushChange,
    chordItems,
    updateRepeat
  } = initializeTabsLogic(lyricsCharts, changes, setChanges)

  const lyricsStructure = chordItems(lyricsCharts || [])

  useEffect(() => {
    setSongStructure(lyricsStructure)
  }, [changes.length])
  const { observe, inView } = useInView({
    onEnter: ({ unobserve }) => unobserve()
  })
  const LyricsCharts = (chordItems: ChordItem[], isBlurred): JSX.Element => {
    const isHiddenForMobile = isMobile() && isBlurred
    return (
      <>
        <div ref={observe}>
          {inView && (
            <>
              <SongDetails song={song} pushChange={pushChange}>
                <SongActions
                  song={song}
                  songKey={song.key}
                  chordCharts={chordItems}
                  lyrics={true}
                />
              </SongDetails>
              <div className={styles.tabContainer}>
                <div className={styles.songStructure}>
                  <h3>{t('Song Structure')}</h3>
                  {hasChanges() && (
                    <div className={styles.undoButtons}>
                      <button onClick={backToDefault}>
                        {t('< back to default')}
                      </button>
                      | <button onClick={undo}>{t('undo')}</button>
                    </div>
                  )}
                </div>
                {!isHiddenForMobile && (
                  <SortableList
                    items={chordItems}
                    pushChange={pushChange}
                    updateRepeat={updateRepeat}
                  />
                )}
              </div>
            </>
          )}
        </div>

        {chordItems && !isHiddenForMobile && (
          <div className={styles.partContainer}>
            <div className={styles.songParts}>
              {chordItems.map((item) => (
                <SongPart
                  item={item}
                  key={item.id}
                  pushChange={pushChange}
                  isLyrics={true}
                />
              ))}
            </div>
          </div>
        )}
      </>
    )
  }

  if (currentUser || lyricsCharts?.length) {
    return LyricsCharts(lyricsStructure, false)
  } else {
    return (
      <BlurredContent
        message={t('SIGN IN TO UNLOCK THIS CONTENT')}
        isSignedIn={!!currentUser}
        isActive={true}
        topIndent="12%"
      >
        {LyricsCharts(fakeChordItems(), true)}
      </BlurredContent>
    )
  }
}
export default LyricsTab
